import { helpers } from '@vuelidate/validators';

export const passwordRegex = helpers.regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/);
export const password = helpers.withMessage(() => 'test', passwordRegex);
